import api from '../utils/api';

export async function listIntegrationApps() {
  const { data } = await api.get('/integration-apps/');
  return data;
}

export async function createIntegrationApp(payload) {
  const { data } = await api.post('/integration-apps/', payload);
  return data;
}

export async function updateIntegrationApp(id, payload) {
  const { data } = await api.put(`/integration-apps/${id}`, payload);
  return data;
}

export async function deleteIntegrationApp(id) {
  const { data } = await api.delete(`/integration-apps/${id}`);
  return data;
}
